import React from "react";

const ShimmerSuggestionList = ({ count = 4 }) => (
  <div className="flex flex-col gap-6">
    {Array(count).fill(0).map((_, i) => (
      <div key={i} className="flex gap-4 items-center">
        <div className="rounded-xl bg-slate-300 animate-pulse w-40 h-24" />
        <div className="flex flex-col gap-3 flex-1">
          <div className="rounded-md bg-slate-300 animate-pulse h-5 w-3/4" />
          <div className="rounded-md bg-slate-300 animate-pulse h-4 w-1/2" />
          <div className="rounded-md bg-slate-300 animate-pulse h-4 w-2/3" />
          <div className="rounded-md bg-slate-300 animate-pulse h-4 w-1/3" />
        </div>
      </div>
    ))}
  </div>
);

export default ShimmerSuggestionList;
